import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaPropostas extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      data: [],
      isLoading: true,
      isError: false,
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,
      disabledInput: true,
      disabledInputValuePlan: true,

      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,

      showDateActive: false,
      searchTerm: '',
      searchField: 'firstName',
      isSearching: false,
      isPaginationLoading: false,
      isDefaultUser: false,
    };

    this.handleSearch = this.handleSearch.bind(this);

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 35,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '5px',
        letterSpacing: 0,
        textTransform: 'uppercase',
        padding: 0,
        height: 35,
        fontSize: 8.5,
      }
    }

  }


  componentDidMount() {
    this._isMounted = true;
    let userType = localStorage.getItem('planos_y');
    let state = this.state;

    // Define se é um usuário admin
    state.isDefaultUser = userType !== 'SALESMAN' && userType !== 'BROKER';

    // Verifica se exibe ou não a coluna 'Corretora'
    // A lógica final será definida na resposta da API baseada no brokerDefault
    if (state.isDefaultUser)
      state.showColBroker = true;
    else
      state.showColBroker = false;

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType === 'SALESMAN') {
      state.showColSalesman = false;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = true;
    }
    else
      state.showColSalesman = true;

    if (userType === 'REGISTER' || userType === 'PARCERIASPJ' || userType === 'AFTER SALES') {
      state.showFirstPayment = true;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = false;
    }

    this.setState(state);

    this.getFilterName();
    this.getData(true, false);
  }

  componentWillUnmount() {
    // Limpa o timeout de busca
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    // Flag para evitar atualizações de estado após desmontagem
    this._isMounted = false;
  }

  applyCpfMask(value) {
    const numbers = value.replace(/\D/g, '');
    
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 6) {
      return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    } else if (numbers.length <= 9) {
      return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
    } else {
      return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
    }
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpf") {
      state.titlePage = "TODAS AS PROPOSTAS - PF";
      state.apiPage = 'all';
    }
    else if (page === "pendentespf") {
      state.titlePage = configBase.statusPendente + " - PF";
      state.apiPage = 'awaitingSolution';
    }
    else if (page === "emaverbacaopf") {
      state.titlePage = configBase.statusEmAverbacao + " - PF";
      state.apiPage = 'inAverbation';
    }
    else if (page === "funcempresa") {
      state.titlePage = configBase.statusFuncEmpresa;
      state.apiPage = 'funcEmpresas';
    }
    else if (page === "indeferidaspf") {
      state.titlePage = configBase.statusIndeferida + " - PF";
      state.apiPage = 'pending';
    }
    else if (page === "emanalisepf") {
      state.titlePage = configBase.statusEmAnalise + " - PF";
      state.apiPage = 'waitingConfirmation';
    }
    else if (page === "novaspf") {
      state.titlePage = configBase.statusNova + " - PF";
      state.apiPage = 'clientConfirmation';
      state.showColStage = true;
    }
    else if (page === "implantadaspf") {
      state.titlePage = configBase.statusImplementadas + " - PF";
      state.apiPage = 'implantedContracts';
      state.showDateActive = true;
      state.showSearchDate = false;
    }
    else if (page === "canceladaspf") {
      state.titlePage = configBase.statusCanceladas + " - PF";
      state.apiPage = 'canceledContracts';
    }
    else
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }

  getData(table = false, searchDate = false) {
    // Para o tipo dos dados da tabela
    let typeBox = this.state.apiPage;
    let url = configBase.api + 'Sales/dataDashboardFilter?access_token=' + localStorage.getItem('planos_t');
    
    // Parâmetros para enviar
    let filter = {
      userId: localStorage.getItem('planos_u'),
      limit: this.state.itemsPerPage,
      skip: this.state.currentPage * this.state.itemsPerPage
    };

    // Se houver um termo de busca
    if (this.state.searchTerm) {
      switch (this.state.searchField) {
        case 'namePlan':
          filter.namePlan = String(this.state.searchTerm);
          break;
        case 'firstName':
        case 'email':
        case 'salesmanName':
        case 'brokerName':
          filter[this.state.searchField] = String(this.state.searchTerm);
          break;
        case 'proposalNumber':
          // Garante que proposalNumber seja sempre string
          filter.proposalNumber = String(this.state.searchTerm);
          break;
        case 'cpf':
          filter.cpf = this.state.searchTerm.replace(/\D/g, ''); // Remove máscara
          break;
        default:
          filter[this.state.searchField] = String(this.state.searchTerm);
      }
    }

    // Adiciona o content ao filtro se não for 'all'
    if (typeBox !== null && typeBox.length > 0 && typeBox !== 'all') {
      filter.content = typeBox;
      
      // Caso seja uma pesquisa com a data inicial e final
      if (searchDate === true) {
        filter.date = {
          startDate: this.state.date.startDate.value,
          endDate: this.state.date.endDate.value
        };
      }
    }

    if (typeBox === null) {
      if (!this._isMounted) return;
      
      let state = this.state;
      state.data = 'zero';
      this.setState(state);
    }
    else {
      axios.post(url, filter)
        .then((response) => {
          if (!this._isMounted) return;
          
          let state = this.state;
          state.isSearching = false;
          state.isPaginationLoading = false;

          const isDefaultSalesman = response.data.salesmanDefault === true;
          const isDefaultBroker = response.data.brokerDefault === true;
          
          if (state.isDefaultUser || isDefaultSalesman || isDefaultBroker) {
            state.showColSalesman = true;
            state.showColBroker = true;
          }

          if (state.isDefaultUser) {
            state.showColBroker = true;
          }
          const userType = localStorage.getItem('planos_y');
          if (userType === 'BROKER') {
            state.showColBroker = false;
          }

          const allPlans = Array.isArray(response.data.plans) ? response.data.plans : [];
          if (allPlans.length === 0) {
            state.data = 'zero';
            state.totalItems = 0;
          }
          else {
            this.setColorStatus(allPlans);
            state.totalItems = response.data.count || allPlans.length;
          }

          if (table === true && state.showTable === false) {
            state.showTable = true;
          }

          state.loadingTable = null;
          this.setState(state);

        })
        .catch(function () {
          if (!this._isMounted) return;
          
          let state = this.state;
          state.data = 'error';
          state.isSearching = false;
          state.isPaginationLoading = false;
          this.setState(state);
        }.bind(this));
    }

  }

  setColorStatus(proposals) {
    let colors = {
      'PAGAMENTO PENDENTE': { color: configBase.bgPendente, name: configBase.statusPendente },
      'EM VALIDAÇÃO': { color: configBase.bgEmAnalise, name: configBase.statusEmAnalise },
      'PENDENTE': { color: configBase.bgIndeferida, name: configBase.statusIndeferida },
      'CANCELADO': { color: configBase.bgCanceladas, name: configBase.statusCanceladas },
      'EM AVERBAÇÃO': { color: configBase.bgEmAverbacao, name: configBase.statusEmAverbacao },
      'AGUARDANDO CONFIRMAÇÃO': { color: configBase.bgNova, name: configBase.statusNova },
      'NOVAS': { color: configBase.bgNova, name: configBase.statusNova },
      'ATIVO': { color: configBase.bgImplementadas, name: configBase.statusImplementadas },
      'FUNCIONÁRIO DE EMPRESA': { color: configBase.bgFuncEmpresa, name: configBase.statusFuncEmpresa },
    };
    let state = this.state;

    for (let i = 0; i < proposals.length; i++) {
      if (colors[proposals[i].status]) {
        proposals[i].color = colors[proposals[i].status].color;
        proposals[i].status = colors[proposals[i].status].name;
      } else {
        // Valores padrão para status não mapeados
        proposals[i].color = configBase.bgNova || '#f0f0f0';
        proposals[i].status = proposals[i].status || 'NOVAS';
      }
    }

    state.data = proposals;
    state.showTable = true;
    state.loadingTable = null;
    this.setState(state);
  }

  sendDetails(salesId) {
    if (salesId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopf?p=${salesId}`);
    }
  }

  sendDetailsFm(financialManagerId) {
    this.props.history.push(`${process.env.PUBLIC_URL}/resumosimples?fm=${financialManagerId}`);
  }

  calculaDesconto(responsibility, valorDesconto, valorDescontoAnual) {
    if (valorDesconto || valorDescontoAnual) {
      let resposta = 0;

      responsibility = responsibility ? parseFloat(responsibility.replace(',', '.')) : 0;
      valorDesconto = valorDesconto ? parseFloat(valorDesconto.toString().replace(',', '.')) : 0;
      valorDescontoAnual = valorDescontoAnual ? parseFloat(valorDescontoAnual.toString().replace(',', '.')) : 0;

      resposta = responsibility - valorDesconto - valorDescontoAnual;

      if (resposta > 0)
        return resposta.toFixed(2).replace('.', ',');
      else
        return responsibility.toFixed(2).replace('.', ',');
    }
    else
      return responsibility;
  }

  handleSearch = (e) => {
    let searchValue = e && e.target ? e.target.value : '';
    
    if (this.state.searchField === 'cpf') {
      searchValue = this.applyCpfMask(searchValue);
    }
    
    this.setState({
      searchTerm: searchValue,
      currentPage: 0,
      isSearching: true
    }, () => {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getData(true);
      }, 500);
    });
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          {/* ############# CAMPO DE PESQUISA - SEMPRE VISÍVEL ############# */}
          {this.state.data !== 'loading' && (
            <div>
               <Grid container spacing={2}>
                 <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                 <Grid item xs={12} sm={12} md={3} lg={3} style={{marginBottom: 20, marginTop: 14}}>
                   <Paper elevation={1}>
                     <IconButton style={{padding: '6px 5px'}} aria-label="search">
                       <SearchIcon />
                     </IconButton>
                     <select
                       style={{
                         border: 'none',
                         background: 'transparent',
                         marginRight: '2px',
                         padding: '2px',
                         outline: 'none'
                       }}
                       value={this.state.searchField}
                       onChange={(e) => {
                         this.setState({
                           searchField: e.target.value
                         });
                       }}
                      >
                        <option value="firstName">Nome Resp.</option>
                        <option value="cpf">CPF</option>
                        <option value="email">Email</option>
                        {(this.state.isDefaultUser || this.state.showColSalesman) && (
                          <option value="salesmanName">Vendedor</option>
                        )}
                        {(this.state.isDefaultUser || this.state.showColBroker) && (
                          <option value="brokerName">Corretora</option>
                        )}
                        <option value="namePlan">Plano</option>
                        <option value="proposalNumber">Proposta</option>
                      </select>
                     <InputBase
                       id="mySearchText"
                       style={this.styles.inputSearch}
                       placeholder="Pesquisar"
                       value={this.state.searchTerm || ''}
                       onChange={this.handleSearch}
                       inputProps={{ 'aria-label': 'pesquisar propostas' }}
                     />
                   </Paper>
                 </Grid>
               </Grid>
            </div>
          )}
          {/* ############# FIM CAMPO DE PESQUISA ############# */}
          
          {/* Loading durante pesquisa */}
          {this.state.isSearching && (
            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
              <Grid item xs={12} sm={12} md={8} lg={8} style={{textAlign: 'center', marginTop: 20}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  Pesquisando...
                </Typography>
              </Grid>
            </Grid>
          )}

          {
          this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Erro ao carregar propostas. Tente novamente.</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
                !this.state.isSearching && (
            <div id="listaPropostaTabela">
              {/* Loading indicator para paginação - aparece no lugar da tabela */}
              {this.state.isPaginationLoading && (
                <Grid container spacing={0} style={{marginTop: 40}}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center'}}>
                    <LinearProgress />
                    <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                      CARREGANDO...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                </Grid>
              )}
              
              <div style={{display: this.state.isPaginationLoading ? 'none' : 'block'}}>
                {/* ############# CSS PARA DATATABLE ############# */}
                <link
                  rel="stylesheet" type="text/css"
                  href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
                />
                <link
                  rel="stylesheet" type="text/css"
                  href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
                />
                {/* ############# CSS PARA DATATABLE ############# */}


              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                <thead style={{backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Data
                      </Typography>
                    </th>

                    {
                      this.state.showDateActive === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Implantado
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Proposta
                      </Typography>
                    </th>
                    {
                      this.state.showColBroker === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Corretora
                      </Typography>
                    </th>
                      )
                    }

                    {
                    this.state.showColSalesman === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vendedor
                      </Typography>
                    </th>
                    )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Resp. Financeiro
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        CPF
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        TELEFONE
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Plano
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vidas
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Valor
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Cupom
                      </Typography>
                    </th>

                    {
                      this.state.showColStage === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Estágio
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={
                      item.salesId === null ? (
                        this.sendDetailsFm.bind(this, item.financialManagerId)
                      ) : (
                        this.sendDetails.bind(this, item.salesId)
                      )
                    }
                    style={{cursor:'pointer', height: 35, padding: 0}}
                  >
                    <td style={this.styles.tdDate}>
                      {item.date}
                    </td>

                    {
                      this.state.showDateActive === true && (
                    <td style={this.styles.tdDate}>
                      {item.dateActive}
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.proposalNumber}
                      </Typography>
                    </td>

                    {
                      this.state.showColBroker === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.broker}
                      </Typography>
                    </td>
                      )
                    }

                    {
                      this.state.showColSalesman === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.salesman}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.financialManager}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.cpf}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.cellPhone}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.plan}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.lives}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}} data-order={item.value.replace(',', '')}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        R$ {this.calculaDesconto(item.value, item.valorDesconto, item.valorDescontoAnual)}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.cupomDesconto}
                      </Typography>
                    </td>

                    {
                      this.state.showColStage === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.stageForm}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'nowrap'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, marginRight: 5, fontSize: 8.5}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="itemsPerPage">Linhas por página: </label>
                  <select
                    value={this.state.itemsPerPage}
                    onChange={(e) => {
                      this.setState({
                        itemsPerPage: parseInt(e.target.value),
                        currentPage: 0,
                        isPaginationLoading: true
                      }, () => this.getData(true));
                    }}
                    style={{ background: 'transparent', border: 'none', marginLeft: 10, color: '#707070' }}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span style={{ marginLeft: 15 }}>
                    {this.state.currentPage * this.state.itemsPerPage + 1}-
                    {Math.min((this.state.currentPage + 1) * this.state.itemsPerPage, this.state.totalItems)}
                  </span>
                  {' '}de{' '}
                  <span>{this.state.totalItems}</span>
                  <button
                    onClick={() => {
                      if (this.state.currentPage > 0) {
                        this.setState({
                          currentPage: this.state.currentPage - 1,
                          isPaginationLoading: true
                        }, () => this.getData(true));
                      }
                    }}
                    disabled={this.state.currentPage === 0}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: this.state.currentPage === 0 ? 'default' : 'pointer',
                      opacity: this.state.currentPage === 0 ? 0.5 : 1,
                      marginLeft: 10
                    }}
                  >
                    <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                      <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      if ((this.state.currentPage + 1) * this.state.itemsPerPage < this.state.totalItems) {
                        this.setState({
                          currentPage: this.state.currentPage + 1,
                          isPaginationLoading: true
                        }, () => this.getData(true));
                      }
                    }}
                    disabled={(this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 'default' : 'pointer',
                      opacity: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 0.5 : 1,
                      marginLeft: 10
                    }}
                  >
                    <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                      <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path>
                    </svg>
                  </button>
                </div>
              </div>
              </div> {/* <-- Fechamento do div style={{display: this.state.isPaginationLoading ? 'none' : 'block'}} */}
            </div>
              )
            )
          )
          )
        }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaPropostas.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostas);